import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVk } from '@fortawesome/free-brands-svg-icons'
import { faTelegram } from '@fortawesome/free-brands-svg-icons'
import './Footer.css';

export default function Footer() 
{
    return (
        <footer className="main-footer">
            <div className="container footer">
                <p className="terms">
                    Посещая сайт <a className="policy" href="https://airnet.ru/" target="_blank">airnet.ru</a> вы соглашаетесь с <a className="policy" href="https://airnet.ru/private_policy" target="_blank">Политикой конфиденциальности</a>.<br></br>
                    © Разработка и поддержка сайта, AirNet™ 2026       
                </p>
                <div className="links">
                    <a title="Вконтакте" target="_blank" rel="noreferrer" className="square-link" href="https://vk.com/spbairnet">
                        <FontAwesomeIcon icon={faVk}></FontAwesomeIcon>
                    </a>
                    <a title="Telegram" target="_blank" rel="noreferrer" className="square-link" href="https://telegram.me/AirnetBot">
                        <FontAwesomeIcon icon={faTelegram}></FontAwesomeIcon>
                    </a>
                </div>
            </div>
        </footer>
    )
}